import { registerQuery, useQuery } from 'data-fetching-client';
import { transformBackendViewToInternalFormat } from '../../viewsSearch/dataOperators/backendViews';
import { View } from '../../viewsSearch/types/ViewTypes';
import { defaultPinnedViewsApi } from './defaultPinnedViewsApi';

export const DEFAULT_PINNED_VIEWS_QUERY_NAME = 'portalDefaultViews' as const;

export type PortalDefaultViewsQueryType = {
  objectTypeId: string;
  namespaceName: string;
};

const defaultViewsQueryArguments: (keyof PortalDefaultViewsQueryType)[] = [
  'objectTypeId',
  'namespaceName',
];

export type PortalDefaultViewsResponseType = Array<View> | undefined;

export const PortalDefaultViewsQuery = registerQuery<
  typeof DEFAULT_PINNED_VIEWS_QUERY_NAME,
  PortalDefaultViewsQueryType,
  PortalDefaultViewsResponseType
>({
  fieldName: DEFAULT_PINNED_VIEWS_QUERY_NAME,
  args: defaultViewsQueryArguments,
  fetcher: (args) =>
    defaultPinnedViewsApi
      .get({
        objectTypeId: args.objectTypeId,
        namespaceName: args.namespaceName,
      })
      .then((views) => {
        return views.map((rawView) => {
          return transformBackendViewToInternalFormat(rawView);
        });
      }),
});

export const useGetPortalDefaultViews = ({
  objectTypeId,
  namespaceName,
}: {
  objectTypeId: string;
  namespaceName: string;
}) => {
  return useQuery(PortalDefaultViewsQuery, {
    variables: {
      objectTypeId,
      namespaceName,
    },
  });
};
